const ContactPageDe = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Kontakt</h1>
      <p className="text-gray-600 mb-2">
        Haben Sie Fragen, benötigen Sie Unterstützung oder haben Sie Anregungen/Wünsche? Sie erreichen uns unter:
      </p>

      <div className="space-y-4">
        <p className="text-gray-600">
          <a href="mailto:info@mapprints.de" className="text-blue-600 hover:underline">
            info@mapprints.de
          </a> oder
        </p>

        <a href="mailto:info@mapprints.de" className="text-blue-600 hover:underline">
          info.mapprints@gmail.com
        </a>
      </div>
    </div>
  );
};

const ContactPageEn = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Contact Us</h1>
      <p className="text-gray-600 mb-6">
        Have questions or need support or suggestions/wishes? You can reach us at:
      </p>
    
      <p className="text-gray-600">
        <a href="mailto:info@mapprints.de" className="text-blue-600 hover:underline">
          info@mapprints.de
        </a> or
      </p>

      <a href="mailto:info@mapprints.de" className="text-blue-600 hover:underline">
        info.mapprints@gmail.com
      </a>
    </div>
  );
};

export { ContactPageDe, ContactPageEn };